import styled from 'styled-components'
const borderRadius = '5px'

export const Input = styled.input`
  border-radius: ${borderRadius};
  border-width: 1px;
  border-color: #999999;
  width: 100%;
  font-size: 10pt;
`

export const TitleBox = styled.div`
  align-self: flex-start;
  font-weight: bold;
`
export const EmptyDiv = styled.div`
  height: 12px;
`
export const ErrorText = styled.div`
  color: red;
  font-size: 11px;
  margin-left: 3px;
`
